import Button from "@/components/base/Button";
import { clinicInfo } from "@/mocks/site";

interface CareCtaProps {
  title: string;
  text: string;
  image: string;
}

/**
 * Full-width appointment call-to-action with a premium medical background image
 * and a dark overlay for text contrast.
 */
export default function CareCta({ title, text, image }: CareCtaProps) {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl border border-primary-900">
          <img
            src={image}
            alt="Consultation room at Ortho Spine Care, Trichy"
            title="Book an orthopaedic and spine consultation in Trichy"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div
            className="absolute inset-0 bg-gradient-to-r from-primary-950/94 via-primary-950/85 to-primary-950/60"
            aria-hidden="true"
          ></div>

          <div className="relative grid grid-cols-1 gap-8 px-6 py-12 md:px-12 md:py-16 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-8">
              <h2 className="font-heading text-2xl font-semibold leading-tight text-background-50 md:text-4xl">
                {title}
              </h2>
              <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-background-200 md:text-base">
                {text}
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row lg:col-span-4 lg:justify-end">
              <Button to="/appointment" size="lg" icon="ri-calendar-check-line">
                Book an Appointment
              </Button>
              <Button href={clinicInfo.phoneHref} variant="light" size="lg" icon="ri-phone-fill">
                Call Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}